import React, { Component } from "react";
import { Tabs, Switch } from "antd";

// icons
import { selectUserData } from "../../redux/user/user.selectors";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import CitDashboardPage from "./cit-dashboard.page";
import { selectScreen } from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.selectors";
import CitPowerBIDetailsPage from "./cit-powerBIDetails.page";
import CitCommodityContainerPage from "./cit-commodity-container.page";

class CitContainer extends Component {
  state = { screenKey: 1, switchKey: false };
  render() {
    return (
      <div className="report-tabs" style={{ height: "90vh" }}>
        {this.props.screen === 1 ? (
          <CitCommodityContainerPage />
        ) : this.props.screen === 2 ? (
          <CitPowerBIDetailsPage />
        ) : (
          <CitDashboardPage />
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screen: selectScreen,
});

export default connect(mapStateToProps, null)(CitContainer);
